import { Box, Checkbox, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CardContainer = styled(Box)(() => ({
  margin: '4px',
  padding: '10px',
  borderBottom: '1px solid #0000003b',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const FlexBox = styled(Box)(() => ({
  display: 'flex',
  gap: '20px',
}));

export const NumberTypography = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: '600',
  color: theme.palette.secondary.main,
}));

export const Title = styled(Typography)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
}));

export const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: '4px',
  height: '32px',
  '&.Mui-checked': {
    color: theme.palette.common.grey,
  },
}));
